<script setup lang="ts">
const props = defineProps<{
  show?: boolean;
}>();

onMounted(() => {
  onShow(true);
});

let timeout: number | null;

watch(() => props.show, onShow);
function onShow(skipTimer?: boolean) {
  if (timeout) {
    window.clearTimeout(timeout);
    timeout = null;
  }
  if (props.show) {
    enableDOM.value = true;
  } else {
    if (!skipTimer) {
      timeout = window.setTimeout(() => {
        enableDOM.value = false;
        timeout = null;
      }, 1000);
    } else {
      enableDOM.value = false;
    }
  }
}
const enableDOM = ref(false);
</script>

<template>
  <div
    class="collapse"
    :class="{
      'collapse-close': !show,
      'collapse-open': show,
    }"
  >
    <div
      class="collapse-content"
      v-if="enableDOM"
    >
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.collapse {
  @apply rounded-none w-full min-w-0;
}
.collapse-content {
  @apply p-0;
}
</style>
